import { Grid, Typography, Container, Button } from "@mui/material";
import React, { useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import UniversalAudioLNLimiterimg from "../../assets/images/UniversalAudio1176LNLimiter.png"
import { IoStarSharp } from "react-icons/io5";
import { FaRegCircleDot } from "react-icons/fa6";
import {Link} from "react-router-dom"
import AOS from "aos";


const UniversalAudioLNLimiter = () => {
  useEffect(()=>{
    AOS.init({duration:2000});
    window.scrollTo(0, 0);
}, [])
  return (
    <Grid>
    <div id="product">
      <Container>
        <div className="pro-inner">
          <Row>
            <Col xs="6">
              <div className="image">
                <img src={UniversalAudioLNLimiterimg} alt="" />
              </div>
            </Col>
            <Col xs="6">
              <div className="innerContent">
                <h3 className="sec-head">Universal Audio 1176LN Limiter</h3>
                <p className="para">
                Upon its release in 1967, the 1176 Limiting Amplifier became an instant classic</p>
               
                <p className="price">Call Now</p>
               

                <div className="meta">
                  <div className="category">
                    in <strong>Audio</strong>
                  </div>
                  <div className="rating">
                    <IoStarSharp />
                    <IoStarSharp />
                    <IoStarSharp />
                    <IoStarSharp />
                    <IoStarSharp />
                  </div>
                </div>
                <Button className="theme-btn">
                  <Link to="/Enquiry" >Send Enquiry</Link>
                </Button>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </div>
    <div id="pro-text">
      <Container>
        <div className="headcontent">
          <Row>
            <Col xs="12">
              <div className="pro-inner">
                <h3 className="sec-head">Model Details</h3>
               <p className="para">Upon its release in 1967, the 1176 Limiting Amplifier became an instant classic because of its unique lightning-fast attack and release times, musical Class A output stage, and its wide range of sounds, ranging from subtle, near-transparent compression, to all-out drive and distortion.
</p>
<p className="para">Universal Audio’s 1176LN Classic Limiting Amplifier is a handbuilt, faithful reproduction of Bill Putnam Sr.’s original visionary design — an iconic piece of audio history that had a hand behind classic recordings from Led Zeppelin, The Rolling Stones, Michael Jackson, and more.
</p>
                
                
              </div>
            </Col>
          </Row>
        </div>
     
      </Container>
    </div>
  




  </Grid>
  )
}

export default UniversalAudioLNLimiter